// extracted by mini-css-extract-plugin
export default {"dashboardCard":"Reporting_dashboardCard__ZQHf6","dashboardDescription":"Reporting_dashboardDescription__o9zE5"};